import { Done, Clear } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'
import type { TFunction } from 'i18next'

import type { PreFOTACheckResult } from '@/pages/fota/fota'

type CheckTooltipDetailProps = {
  t: TFunction
  result: PreFOTACheckResult
}

const CheckTooltipDetail = ({ t, result }: CheckTooltipDetailProps) => (
  <div>
    <SingleCheckDetail status={result.isOnline} text={t('di:fota.isOnline')} />
    <SingleCheckDetail
      status={result.isInService}
      text={t('di:fota.inService')}
      optional
    />
    <SingleCheckDetail
      status={result.isKeySwitchOperational}
      text={t('di:fota.keySwitchOperational')}
    />
  </div>
)

type SingleCheckDetailProps = {
  status: boolean
  text: string
  optional?: boolean
}

const SingleCheckDetail = ({
  status,
  text,
  optional,
}: SingleCheckDetailProps) => {
  if (optional === true && status) {
    return null
  }
  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Box>{status ? <Done color="primary" /> : <Clear color="error" />}</Box>
      <Typography variant="h6">{text}</Typography>
    </Box>
  )
}

export default CheckTooltipDetail
